export default "__VITE_ASSET__VAIZnGGF__"